
import M2Client from '@madehq/m2client';
import { defaultsDeep } from 'lodash';

const client = M2Client.instance(window.jsPaths.rest, window.jsPaths.socket);

// @todo remove when Lee fixes the call in flight problem
const cache = {};

const defaultParams = {
    urlParams: {},
    data: {},
}

const privateGetCaching = {
    cacheTTL: 5 * 60,
    cacheStaleWhileRevalidate: false,
}

const publicGetCaching = {
    cacheTTL: 10 * 60,
    cacheStaleWhileRevalidate: true,
}

const privatePostCaching = {
    cacheTTL: 0,
    cacheStaleWhileRevalidate: false,
}

// Post are private always, public is just cacheable
const publicPostCaching = {
    cacheTTL: 30,
    cacheStaleWhileRevalidate: false,
}

const hash = source => {
    if (typeof source !== 'string' || source instanceof String === false) {
        source = JSON.stringify(source);
    }

    let hash = 0;

    if (!source.length) {
        return hash;
    }

    for (let i = 0; i < source.length; i++) {
        hash = ((hash << 5) - hash) + source.charCodeAt(i);
        hash |= 0;
    }

    return hash;
}

export function privateGet(url, params = {}, caching = {}) {
    const { urlParams } = defaultsDeep({}, params, defaultParams);
    const { cacheTTL, cacheStaleWhileRevalidate } = defaultsDeep({}, caching, privateGetCaching);

    const callConfig = {
        url,
        urlParams,
        cacheTTL,
        cacheStaleWhileRevalidate,
        localCacheType: 'Private',
        callType: 'Rest',
        restMethod: 'Get',
    }

    const key = hash(callConfig);

    if (key in cache) {
        return cache[key];
    }

    cache[key] = client.makeCall(callConfig);

    return cache[key];
}

export function publicGet(url, params = {}, caching = {}) {
    const { urlParams } = defaultsDeep({}, params, defaultParams);
    const { cacheTTL, cacheStaleWhileRevalidate } = defaultsDeep({}, caching, publicGetCaching);

    const callConfig = {
        url,
        urlParams,
        cacheTTL,
        cacheStaleWhileRevalidate,
        localCacheType: 'Public',
        callType: 'Rest',
        restMethod: 'Get',
    }

    const key = hash(callConfig);

    if (key in cache) {
        return cache[key];
    }

    cache[key] = client.makeCall(callConfig);

    return cache[key];
}

export function privatePost(url, params = {}, caching = {}) {
    const { urlParams, data } = defaultsDeep({}, params, defaultParams);
    const { cacheTTL, cacheStaleWhileRevalidate } = defaultsDeep({}, caching, privatePostCaching);

    const callConfig = {
        url,
        urlParams,
        data,
        cacheTTL,
        cacheStaleWhileRevalidate,
        localCacheType: 'Private',
        callType: 'Rest',
        restMethod: 'Post',
    }

    return client.makeCall(callConfig);
}

export function publicPost(url, params = {}, caching = {}) {
    const { urlParams, data } = defaultsDeep({}, params, defaultParams);
    const { cacheTTL, cacheStaleWhileRevalidate } = defaultsDeep({}, caching, publicPostCaching);

    const callConfig = {
        url,
        urlParams,
        data,
        cacheTTL,
        cacheStaleWhileRevalidate,
        localCacheType: 'Private',
        callType: 'Rest',
        restMethod: 'Post',
    }

    return client.makeCall(callConfig);
}

export default {
    privateGet,
    publicGet,
    privatePost,
    publicPost,
}
